export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14790.9f886fe0.jpg";